import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["onClick", "allOption"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { useForkRef } from '@cian/react-utils';
import { SelectInput, useControlledValue } from '../../internal';
import { MultiSelectMobileModal } from './MultiSelectMobileModal';

/**
 * select-компонент для выбора нескольких значений из списка
 *
 * Только мобильный вариант, открывающий список в модальном окне
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const MultiSelectMobile = /*#__PURE__*/React.forwardRef(function MultiSelectMobile(props, forwardedRef) {
  const {
      onClick,
      allOption
    } = props,
    selectInputProps = _objectWithoutProperties(props, _excluded);
  const inputRef = React.useRef(null);
  const ref = useForkRef(forwardedRef, inputRef);
  const [open, setOpen] = React.useState(false);
  const {
    value,
    onChange
  } = useControlledValue(props, []);
  const handleInputClick = React.useCallback(e => {
    if (onClick) {
      onClick(e);
    }
    if (!e.defaultPrevented) {
      setOpen(true);
    }
  }, [onClick]);
  const handleCloseModal = React.useCallback(() => {
    const input = inputRef.current;
    setOpen(false);
    if (input) {
      input.focus();
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectInput, _objectSpread(_objectSpread({}, selectInputProps), {}, {
      ref: ref,
      open: open,
      onClick: handleInputClick,
      role: "button",
      "aria-haspopup": "listbox",
      value: value
    })), /*#__PURE__*/_jsx(MultiSelectMobileModal, {
      options: props.options,
      open: open,
      onClose: handleCloseModal,
      value: value,
      onChange: onChange,
      title: props.title || props.placeholder,
      allOption: allOption,
      dataTestId: props.dataTestId
    })]
  });
});